<template>
    <div class="login_status">
        <v-header></v-header>
        <v-headers></v-headers>
        <div class="status">
            <div class="status_center" v-if="succeed_s">
                <img @click="change('/pre_registration')" class="imgs" src="../assets/images/fh.png" alt />
                <p>エラーが発生しました</p>
                <span>エラー0x000000</span>
                <div>
                    <p>申し訳ござい</p>
                    <p>ませんが、</p>
                    <p>もう一度</p>
                    <p>お試しください</p>
                </div>
                <img class="img_s" src="../assets/images/cz.png" alt />
            </div>
            <div>
                <div class="status_center_s" v-if="succeed">
                    <img @click="change('/pre_registration')" class="imgs" src="../assets/images/fh.png" alt />
                    <p>事前登録成功</p>
                    <span></span>
                    <div class="succeed_s">
                        <p>リリースまで</p>
                        <p>もう暫く</p>
                        <p>お待ち</p>
                        <p>くださいにゃ！</p>
                    </div>
                    <img class="img_s" src="../assets/images/succeed.png" alt />
                </div>
            </div>
        </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/dmmheader.vue";
import Headers from "@/components/dmmnavi_header.vue";
export default {
    name: "login_status",
    components: {
        "v-footer": Footer,
        "v-header": Header,
        "v-headers": Headers
    },
     data: () => ({
         succeed:false,
         succeed_s:false,
     }),
    created() {
        let h = this.$route.query.h

        if(h) {
            // 请求结果
            this.request(h)
        } else {
            this.succeed = false;
            this.succeed_s = false;
        }
    },
    methods: {
        request(h) {
            this.axios
                .get("/checkout_login_status", {
                    params: {
                        h
                    }
                })
                .then(v => {
                    console.log(v)

                    if(v.retcode == 2000) {
                        this.succeed = true;
                         this.succeed_s = false;
                    } else {
                        this.succeed = false;
                        this.succeed_s = true;
                    }
                })
                .catch(e => {
                    console.log(e);
                });
        },
         change(path){
             this.$router.push(path)
        },
    }
};
</script>

<style lang="scss" scoped>
.login_status {
    width: 100%;
    .status {
        height: 23.57692rem;
        width: 100%;
        background: url("../assets/images/login.png");
        background-size: cover;
        position: relative;
        @media screen and (max-width: 600px) {
            height: pxTorem(780px);
        }
        .status_center,
        .status_center_s {
            position: absolute;
            width: pxTorem(436px);
            height: pxTorem(476px);
            top: pxTorem(74px);
            left: pxTorem(432px);
            border: pxTorem(3px) solid #cc9764;
            background: #171f38;
            .succeed_s {
                margin-top: pxTorem(80px);
                margin-left: pxTorem(49px);
                p {
                    color: #ececec;
                }
            }
            @media screen and (max-width: 600px) {
                left: 50%;
                top: pxTorem(160px);
                margin-left: pxTorem(-218px);
            }
            .imgs {
                cursor:pointer;
                position: absolute;
                width: pxTorem(54px);
                left: pxTorem(11px);
                top: pxTorem(11px);
            }
            p {
                font-size: pxTorem(37.62px);
                margin: pxTorem(62px) 0 pxTorem(20px);
                font-weight: 900;
                color: #e8af71;
                text-align: center;
            }

            span {
                font-size: pxTorem(12.64px);
                color: #8f8f8f;
                font-family: inherit;
                margin-left: pxTorem(174px);
            }

            div {
                margin-top: pxTorem(120px);
                margin-left: pxTorem(49px);
                p {
                    color: #8f8f8f;
                    margin: 0;
                    line-height: pxTorem(28px);
                    font-size: pxTorem(22.36px);
                    font-family: inherit;
                    text-align: left;
                }
            }
            .img_s {
                position: absolute;
                bottom: 0;
                right: 0;
                width: pxTorem(255px);
            }
        }
    }
}
</style>
